import { render, staticRenderFns } from "./PhoneConsulting.vue?vue&type=template&id=2dd3fee6&scoped=true&"
import script from "./PhoneConsulting.vue?vue&type=script&lang=js&"
export * from "./PhoneConsulting.vue?vue&type=script&lang=js&"
import style0 from "./PhoneConsulting.vue?vue&type=style&index=0&id=2dd3fee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3fee6",
  null
  
)

export default component.exports